import React from 'react';

import { InfiniteScroll } from '@/reconstruction/components/public';
import { NextImage } from '@/components/public';
import { formatMts } from '@/utils';
import type { MediaDataType } from '@/type/media';

import styles from './index.module.less';

function Index({
    noDataRender,
}: {
    /** 没数据时展示内容 */
    noDataRender: any;
}) {
    return (
        <div className={styles.wrapper}>
            <InfiniteScroll
                api="/japi/media/management/list"
                method="post"
                noDataRender={noDataRender(true)}
                renderList={(list) => {
                    return (
                        <div className={styles.list}>
                            {list.map((item: MediaDataType, index) => {
                                const { url, titleMts, jumpLink } = item;
                                return (
                                    <a href={jumpLink} target="_blank" key={index} className={styles.item}>
                                        <div className={styles.item__img}>
                                            <NextImage src={url} layout="fill" />
                                        </div>
                                        <div className={styles.title}>{formatMts(titleMts)}</div>
                                    </a>
                                );
                            })}
                        </div>
                    );
                }}
            />
        </div>
    );
}

export default Index;
